import FormLayout from './FormLayout'
import ANTDButton from '../../../shared/antd/ANTDButton'
import ANTDColumn from '../../../shared/antd/ANTDColumn'
import ANTDForm from '../../../shared/antd/ANTDForm'
import ANTDRow from '../../../shared/antd/ANTDRow'
import addEditEquipment from '../container/addEditEquipment.container'

const AddEditEquipment = ({ editData, buildingId, onAddSuccess }) => {
  const { t, form, equipmentFormFields, onSaveClick, handleValuesChange } =
    addEditEquipment({
      editData,
      buildingId,
      onAddSuccess,
    })

  return (
    <>
      <ANTDForm
        name="add-equipment"
        form={form}
        onValuesChange={handleValuesChange}
        onFinish={onSaveClick}
        layout="vertical"
        className="add-equipment-form"
      >
        <FormLayout formFieldAttributes={equipmentFormFields} />

        <ANTDRow>
          <ANTDColumn sm={24} className="text-center">
            <ANTDButton
              // loading={loader}
              type="primary"
              htmlType="submit"
              className="submit-btn"
            >
              {t('btn_Save')}
            </ANTDButton>
          </ANTDColumn>
        </ANTDRow>
      </ANTDForm>
    </>
  )
}

export default AddEditEquipment
